import React, { useState , useEffect , useRef  } from "react";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from "react-helmet" ;
import { Cookies } from '../../index.js';
import Iframe from 'react-iframe';
import '../../profile.css';
import { Parser } from 'html-to-react';
import AdModal from '../../app_structure/AdModal';
function Profiletruyenchu() {
    const [showAd, setShowAd] = useState(true);
    const [metadoctruyen, setmetadoctruyen] = useState(null);
    const [dulieumeta, setdulieumeta] = useState("");
    const [mota, setmota] = useState("");
    const [tatquangcao, settatquangcao] = useState(Cookies.get('tatquangcao'));
    const [chap1, setchap1] = useState("");
    const [listtruyen, setlisttruyen] = useState("");
    const [tentacpham, settentacpham] = useState("");
    const [random, setRandom] = useState(null);
    const [linkanh, setlinkanh] = useState("");
    const [chapmoi, setchapmoi] = useState("");
    const [trangthai, settrangthai] = useState("");
    const [author, setauthor] = useState("");
    const [rate, setrate] = useState("");
    const handleCloseAd = () => {
        setShowAd(false);
      };
    const laydulieutruyen = async () => {
        const path = window.location.pathname;
        const start = path.lastIndexOf('/profile/') + '/profile/'.length;
        const end = path.length;
        const slug_2 = path.substring(start, end);
        axios.get( 'https://hust.media/truyenchuapi/profile.php?linktruyen=' + slug_2 )
        .then(response => {
 
         const jasdnkasd = response.data ;
          setmota(jasdnkasd.mota) ;
        //   const newUrl = jasdnkasd.chap1.replace('https://hust.media', '');
        //   setchap1(newUrl) ; 
          setlisttruyen(jasdnkasd.listtruyen) ; 
          settentacpham(jasdnkasd.tentacpham) ;
          setlinkanh(jasdnkasd.anhtruyen) ;
          setrate(jasdnkasd.rate) ;
          settrangthai(jasdnkasd.trangthai) ;
          setauthor(jasdnkasd.author) ;
          setchapmoi(jasdnkasd.chapmoi) ;
          setmetadoctruyen(jasdnkasd.metadoctruyen);
          console.log(jasdnkasd.metadoctruyen);
        })
        .catch(error => {
      
        });
      }
      const laydulieumeta = async () => {
        const path = window.location.pathname;
        const start = path.lastIndexOf('/profile/') + '/profile/'.length;
        const end = path.length;
        const slug_2 = path.substring(start, end);
        axios.get( 'https://hust.media/truyen-tranh/metadoctruyen2.php/' + slug_2 )
        .then(response => {
            const htmlParser = new Parser();
            const parsedHtml = htmlParser.parse(response.data);
            setdulieumeta(parsedHtml);

            
        })
        .catch(error => {
      
        });
      }
    useEffect(() => {
        laydulieutruyen();
        // laydulieumeta();
        const randomNumber = Math.floor(Math.random() * 4);
        setRandom(randomNumber);
        console.log(randomNumber);
      }, []);
    return (
        <>
        {
      
        
        random == 1 && tatquangcao != 'ok'  ? (
  <Helmet>
    {/* <script async="async" data-cfasync="false" src="//ophoacit.com/1?z=5904788"></script> */}
  </Helmet>
) : random == 2  && tatquangcao != 'ok' ? ( 
  <AdModal isOpen={showAd} onClose={handleCloseAd} />
 )  : random == 3  && tatquangcao != 'ok' ? ( 
<Helmet>
<script data-cfasync="false" type="text/javascript" src="//usjbwvtqwv.com/bultykh/ipp24/7/bazinga/1979702" async></script>

        </Helmet>
) : (
<></>
)

}

    <div className="container">
    <>     <div className="header-container">
      <img src={linkanh}
       alt="" className="header-image" />
      <div className="headertruyen">
        <svg href="javascript:void(0)" fill="#ffffff" height="18" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg" className="header-icon">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
        </svg>
  <a href="https://hust.media/nativeapp/search" >
        <svg fill="#ffffff" height="18" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg" className="u-float-right header-icon">
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          <path d="M0 0h24v24H0z" fill="none"/>
        </svg></a>
        {!tentacpham && (
        <>
       
        <h1 className="main-heading">Please wait a moment 😊 <br></br>Đang tải truyện</h1>
 </>  
          ) }
       
        <div v-if="tentacpham">
        <h1 className="main-heading">{ tentacpham }</h1>
    </div>

        <span className="tag">đang cập nhật</span>
        <span className="tag">đang cập nhật</span>
        <div className="stats">
          <span className="stat-module">
          { author && (<>      Tác giả  <span className="stat-number"> {author} </span>
            </>   )  }     </span>
          <span className="stat-module">
          { rate && (<>    Đánh giá <span className="stat-number"> {rate} </span>
       </>   )  } 
          </span>
          <span className="stat-module">
          { trangthai && (<>
            Trạng thái <span className="stat-number">{ trangthai }</span>
          </>   
      )  } </span>
        </div>
      </div>
    </div>
    
    <div className="overlay-header"></div>

   </>       { dulieumeta ? (
        
        <>
     
    <Helmet>
    {dulieumeta}      </Helmet> 
    </>   ) : (   <Helmet><title></title></Helmet>  )} 
          <div className="bodyok">
          {chap1 && (
            <>
        <Link to={chap1}>
            <img  src="https://i.pinimg.com/originals/50/8f/11/508f1181449ccca9dc2f8f49afdc928b.gif"
             alt="Hugh Jackman" className="body-image ava w-16 h-16" />
        </Link> </>
          ) }
      <div className="body-action-button u-flex-center">
        <svg fill="#ffffff" height="28" viewBox="0 0 24 24" width="28" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
          <path d="M0 0h24v24H0z" fill="none"/>
        </svg>
      </div>
      {/* <span className="body-stats">Followers <span>3.5k</span></span>
      <span className="body-stats">Following <span>1.9k</span></span> */}
      <div className="u-clearfix"></div>
      <div  className="body-info" >
        <p>
         { mota }
        </p>
      </div>
      <div  className="body-more">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="card cardtruyenok u-clearfix">
        <span className="card-heading">Chap mới nhất</span>
        <span className="card-more">
          <svg fill="#777777" height="18" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
          </svg>
        </span>
        <div className="  mx-auto rounded-lg shadow-xl">

<div className=" items-center justify-between ">
        {listtruyen ? (
            <>
               { metadoctruyen && (
          <>

         <Helmet>
        <title>{metadoctruyen.title}</title>
        <meta name="description" content={metadoctruyen.description} />
        <meta name="keywords" content={metadoctruyen.keywords} />
        {metadoctruyen.og_tags.map((tag, index) => (
          <meta key={index} property={tag.property} content={tag.content} />
        ))}
      </Helmet></>
       
      )}
            {listtruyen.map((item, index) => (
        <Link to={item.link} key={index} style={{ textDecoration: "none" }}>
        <div className="text-blue-600 md:text-green-600"> { item.chap }&nbsp;  { item.time } </div> 
         
        </Link>
        ))} </>  )
        : (  <div  className="text-center spinner-border" role="status">
                 
        </div> )   }

        
  <br></br>
    
        <ul className="card-list">
         
        </ul>   </div>
        <span className="card-heading">Danh sách chap</span>
        <Iframe
                data-aa="2271984"
                url="//acceptable.a-ads.com/2271984"
                width="100%"
                className="max-h-20 mt-2" // 1 rem tương đương 4
                frameBorder="0"
                scrolling="no"
                allowFullScreen
              />
        <div className=" items-center justify-between ">
        {chapmoi && (
            <>
            {chapmoi.map((item, index) => (
        <Link to={item.link} key={index} style={{ textDecoration: "none" }}>
        <div className="text-blue-600 md:text-green-600"> { item.chap }&nbsp;  { item.time } </div> 
         
        </Link>
        ))} </>  )
          }

        
  <br></br>
  </div>
    </div>
      </div>
    </div>
    </div> </> );
}

export default Profiletruyenchu;
